@if (displayDocumentUploadIndicator) {
    @switch (documentUploadSEPStatus) {
        @case ("PRODUCER_REQUESTED") {
            <!-- Sent -->
            <span class="material-symbols-outlined" matTooltip="Documents Requested, Awaiting Upload">inactive_order</span>
        }
        @case ("CONSUMER_COMPLETED") {
            <!-- Complete -->
            <span class="material-symbols-outlined" matTooltip="Documents Uploaded, Ready to Complete">order_approve</span>
        }
        @default {
            <!-- Unsent -->
            <span class="material-symbols-outlined" matTooltip="Documents Needed, Request Unsent">order_play</span>
        }
    }
}
